import { accessRole } from '../../../../../../helpers/access_role'
import { config } from "../../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { Tooltip, Label, Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from "reactstrap"

import MKIDatatable from '../../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../../helpers/ui/alert'

import Select from '../../../../../../helpers/ui/CustomSelect'

import { AvForm, AvField } from "availity-reactstrap-validation"

import { cancelToken } from "../../../../../../services/adapters/kepegawaian/diklatService"

import DataTableBloc from '../Blocs/IndexBloc'
import apiResponse from '../../../../../../services/apiResponse'

const reformatDate = (date) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const d = new Date(date);
    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    if (date) {
        return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};



class TableActiveComponent extends Component {

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")

    dataTableBloc = new DataTableBloc();

    source
    defaultOrder = 'official_travel_id'
    defaultSize = 10
    defaultSort = 'desc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            approveUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            cancelUuid: null,
            defaultSize: 10,
            rows: [],
            totalRow: 0,
            loadingTable: false,
            filter: 
                {
                    filter_value: "",
                    page_number: 1,
                    page_size: this.defaultSize,
                    sort_order: {
                        column: this.defaultOrder,
                        order: this.defaultSort
                    }
                }
        }
    }

    toggleApprovalModal = () => this.setState({ approvalModal: !this.state.approvalModal })
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadData = async () => {
        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            employee_uuid : this.peg_uuid,
            training_type: this.props.type,
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            date_start: this.props.filter?.dateStart,
            date_end: this.props.filter?.dateEnd,
            status: 1
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadData()
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.inactiveData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }
    
    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ uuid: this.state.inactiveUuid })
    }

    componentDidMount() {
        // this.setTokenAPI()

        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true
                    }, function () {
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    // componentDidUpdate(prevProps) {
    //     if(prevProps.type !== this.props.type) {
    //         this.loadData()
    //     }
    //     if(prevProps.filter != this.props.filter) {
    //         this.loadData()
    //     }
    // }

    componentWillUnmount() {
        this.dataTableBloc?.rowtableChannel?.unsubscribe()
    }

    columns = [
        {
            key: "official_travel_number",
            text: "Nomor ST",
            sortable: true,
        },
        {
            key: "official_travel_domicile",
            text: "Tujuan",
            sortable: true,
            cell: record => {
                let oversea = record.official_travel_oversea == 1 ? 'Dalam Negeri' : 'Luar Negeri' 
                let domicile = record.official_travel_domicile == 1 ? 'Dalam Kota' : 'Luar Kota'
                return (
                    <span>
                        {record.official_travel_oversea != 1 && 
                            <Fragment>
                                <Label>{oversea}</Label> <br/>
                            </Fragment>
                        }
                        {record.official_travel_domicile &&
                            <Fragment>
                                <Label>Domisili: {domicile}</Label> <br/>
                            </Fragment>
                        }
                        {record.official_travel_province &&
                            <Fragment>
                                <Label>Provinsi: {record.official_travel_province}</Label> <br/>
                            </Fragment>
                        }
                        {record.official_travel_city &&
                            <Fragment>
                                <Label>Kota: {record.official_travel_city}</Label> <br/>
                            </Fragment>
                        }
                        {record.official_travel_destination &&
                            <Label>Tempat: {record.official_travel_destination}</Label>
                        }
                    </span>
                )
            }
        },
        {
            key: "official_travel_start_date",
            text: "Tanggal Mulai",
            sortable: true,
            cell: record => {
                return reformatDate(record.official_travel_start_date)
            }
        },
        {
            key: "official_travel_end_date",
            text: "Tanggal Selesai",
            sortable: true,
            cell: record => {
                return reformatDate(record.official_travel_end_date)
            }
        },
        {
            key: "official_travel_description",
            text: "Keterangan",
            sortable: true,
        },
        {
            key: "official_travel_approval_status",
            text: "Status",
            className: "need_approval",
            sortable: true,
            align: 'center',
            width: 120,
            cell: record => {
                var need_approval = record.official_travel_approval_status
                return (
                    <span>
                        { need_approval == 0 &&
                            <label className="badge rounded-pill bg-soft-warning font-size-12" >Menunggu Approval</label>
                        }
                        { need_approval == 1 &&
                            <label className="badge rounded-pill bg-soft-success font-size-12" >Disetujui</label>
                        }
                        { need_approval == 2 &&
                            <label className="badge rounded-pill bg-soft-info font-size-12" >Ditolak</label>
                        }
                        { need_approval == 9 &&
                            <label className="badge rounded-pill bg-soft-danger font-size-12" >Dibatalkan</label>
                        }
                    </span>
                )
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 160,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.official_travel_id
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-" + thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.official_travel_uuid
                                    })
                                }}
                                style={{
                                    marginRight: '2px',
                                    padding: '2px 5px'
                                }}>
                                    <i className="uil-align-left"></i>
                            </button>
                            <Tooltip
                                style={{
                                    marginBottom: 2
                                }}
                                placement="top" isOpen={this.state["detail" + thisId]} target={"detail-" + thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail" + thisId] : !this.state["detail" + thisId]
                                    })
                                }}
                            >Detail</Tooltip>
                        </span>
                    </Fragment>
                );
            }
        }
    ]

    render() {
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menghapus data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil dihapus"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal dihapus"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.detailUuid !== null ?
                    <Redirect to={`/izinpegawai/dinas.html?detail&uuid=${this.state.detailUuid}`}/>
                : null }
                { this.state.updateUuid !== null ?
                    <Redirect to={`/izinpegawai/dinas.html?update&uuid=${this.state.updateUuid}`}/>
                : null }
                { this.state.approveUuid !== null &&
                    <Redirect to={`/izinpegawai/dinas.html?approve&uuid=${this.state.approveUuid}`} />
                }
                { this.state.cancelUuid !== null &&
                    <Redirect to={`/izinpegawai/dinas.html?cancel&uuid=${this.state.cancelUuid}`} />
                }
            </>
        )
    }

}

export default TableActiveComponent